export default __webpack_public_path__ + "static/media/tick.093566d5.svg";